export default function IconAddNote() {
  return (
    <svg height="26" width="26">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        d="M12 2 L20 2 A4 4 0 0 1 22 4 L22 14 M14 22 L4 22 A4 4 0 0 1 1 18 L1 12 L12 2 M1 12 L9 12 A3 3 0 0 0 12 9 L12 1 M22 17 L22 25 M18 21 L26 21"
      />
    </svg>
  );
}
